"use client";

import PageLoader from "@/components/common/PageLoader";
import React, { useEffect } from "react";

import { Toaster } from "react-hot-toast";
import { useAppDispatch } from "@/store/store";
import { recoverAuthState } from "@/store/slices/authSlice";

export default function ClientLayout({
  children,
}: {
  children: React.ReactNode;
}) {
  const dispatch = useAppDispatch();

  useEffect(() => {
    // Sanitize auth state on mount to prevent stuck loading screens
    dispatch(recoverAuthState());
  }, [dispatch]);

  return (
    <>
      <Toaster
        position="bottom-right"
        reverseOrder={false}
        toastOptions={{
          duration: 4000,
          style: {
            background: "#161616", // Assetilo dark charcoal
            color: "#E2E2E2", // silver-gray
            borderRadius: "10px",
            border: "1px solid #2a2a2a", // dark-slate
            fontSize: "14px",
            fontWeight: 500,
            padding: "12px 16px",
            boxShadow: "0 10px 15px -3px rgba(0, 0, 0, 0.4)",
          },
          success: {
            style: {
              borderLeft: "4px solid #48C15A",
            },
            iconTheme: {
              primary: "#48C15A",
              secondary: "#161616",
            },
          },
          error: {
            style: {
              borderLeft: "4px solid #FF5252",
            },
            iconTheme: {
              primary: "#FF5252",
              secondary: "#161616",
            },
          },
        }}
      />
      <PageLoader />
      {children}
    </>
  );
}
